<template>
    <div class="mx-auto px-4 md:px-12 bg-gray-200">
        <div class="flex flex-wrap -mx-1 lg:-mx-2 pt-6">

            <span class="block w-full pt-1 text-xl font-semibold mb-4 tracking-wide border-orange-500" style="border-bottom-width: 1px">Gallery</span>


            <div  v-if="loading" class="flex">
                <div class=" mx-auto">
                    <!-- <img alt="school logo" class="object-contain h-10 w-20" src="../images/loading.gif"> -->
                    <vue-loaders
                    name="ball-spin-fade-loader" color="#2a4365" class="mx-auto my-4" scale="1"></vue-loaders>
                </div>
            
            </div>

            <div v-else-if="albums == null || albums == {}">
                <h1>No gallery at the moment</h1>
            </div>

            <!-- Column -->
            <div v-else  v-for="item in albums" :key="item.id" class="my-1 pb-4 px-2 w-full sm:my-6 md:w-1/2 lg:my-4 lg:px-4 lg:w-1/3">

                <!-- Article -->
                <article class="overflow-hidden rounded-md shadow-md mb-10 bg-white pb-1">

<!--                    <a href="#">-->
<!--                        <images alt="Placeholder" class="block h-56 w-full object-cover" :src="item.photos[0].photo_link">-->
<!--                    </a>-->
                    <slider v-if="item.photos.length > 0" :photos="item.photos"></slider>
                    <img v-else alt="Placeholder" class="block h-56 w-full object-cover" src="../../images/loading.gif">

<!--                    <carousel :data="getCarouselData(item)" :controls="false" class="block h-56 w-full object-cover"></carousel>-->

                    <header class="flex items-center justify-between leading-tight p-2">
                        <h1 class="container text-base">
                            <a class="flex-wrap no-underline hover:underline text-black">
                               {{item.title}}
                            </a>
                        </h1>

                    </header>

                    <footer class="flex items-center justify-between leading-none p-2 mr-1">
                        <p class="text-grey-darker text-sm">
                            {{item.date}}
                        </p>

<!--                        <a class="flex items-center no-underline hover:underline text-black" @click="viewDetails(item.img_src)">-->
<!--&lt;!&ndash;                            <images alt="Placeholder" class="block rounded-full" src="https://picsum.photos/32/32/?random">&ndash;&gt;-->
                            <p class="ml-2 text-sm px-3 py-2 rounded-lg bg-blue-200 text-blue-900 cursor-pointer" @click="goToAlbumView(item.id)">
                                View {{item.photos.length}} {{item.photos.length > 1 ? 'photos' : 'photo'}}
                            </p>
<!--                        </a>-->
<!--                        <a class="no-underline text-grey-darker hover:text-red-dark" href="#">-->
<!--                            <span class="hidden">Like</span>-->
<!--                            <i class="fa fa-heart"></i>-->
<!--                        </a>-->
                    </footer>

                </article>
                <!-- END Article -->

            </div>
            <!-- END Column -->


        </div>
    </div>
</template>

<style scoped>


</style>

<script>

    import router from "../../routes";
    import Axios from "axios";
    import slider from "./slider";

    export default {
        name: "photo-gallery",
        components: {slider},
        data: function () {
            return {
                data: [],
                loading: false,
                albums: [],


        }
            ;
        },
        methods: {


            getAlbums:  function(){
                this.loading = true;
                let token = localStorage.getItem('token');
                if(token === null){
                    router.push({name: 'login'});
                    this.$swal('Please log in');
                }else{
                    Axios.get('/api/gallery',
                        {headers: {'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`}}
                    ).then(response => {
                        this.loading = false;
                        // console.log(response.data);
                        if(response.data.status){
                            this.albums = response.data.data;


                        }else{
                            router.push({name: 'login'});
                            this.$swal('Please log in');
                        }
                    });
                }

            },

            goToAlbumView(id){
                this.$router.push(`/gallery/${id}`)
            },

        },

        // computed: {
            // getCarouselData(photos){
            //     console.log(photos);
            //     let data = [];
            //     // photos.forEach((item, index) => {
            //     //     data.push(`<images alt="Placeholder" class="block h-56 w-full object-cover" src=${item.photo_link}>`);
            //     //     console.log(`<images alt="Placeholder" class="block h-56 w-full object-cover" src=${item.photo_link}>`);
            //     // });
            //
            //     return data;
            // }
        // },


        created() {
            this.getAlbums();
        }


    }
</script>
